<template>
  <div>
    <van-overlay :show="showDialog" z-index="99999">
      <div class="body">
        <div class="main">
          <div>登录方式不正确</div>
          <div>请在微信公众号里点击图文链接的方式进入</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import axiosUtil from "../utils/axiosUtil";
export default {
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    // 在缓存中保存用户微信信息
    saveUserInfo() {
      let params = {
        openId: localStorage.getItem("openId"),
      };
      axiosUtil.post("userLogin/getUserInfo", params).then((res) => {
        if (res) {
          if (res.code == 400) {
            this.$dialog.alert({
              title: "",
              message: "微信用户信息取得失败",
            });
          } else {
            localStorage.setItem("weChatUserInfo", JSON.stringify(res.list[0]));
          }
        }
      });
    },
  },
  mounted() {
    let oi = this.$route.query.oi;
    let openId = localStorage.getItem("openId");
    // 不是从公众号菜单进来的
    if (oi == undefined) {
      // 如果缓存中没有openId
      if (openId == "" || openId == null) {
        this.showDialog = true;
      } else {
        // 在缓存中保存用户微信信息
        this.saveUserInfo();
      }
    } else {
      // 从公众号菜单进来的,在缓存中保存openId
      if (openId != null && oi != openId) {
        localStorage.clear();
        this.showDialog = true;
      } else {
        localStorage.setItem("openId", oi);
        // 在缓存中保存用户微信信息
        this.saveUserInfo();
      }
    }
  },
};
</script>

<style scoped>
.body {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main {
  height: 350px;
  width: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  color: red;
  font-size: 16px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/templates/UserInfoHandle.vue